import React from 'react';
import cn from 'clsx';

import Button from '../../library/button/button';
import Typography from '../../library/typography/typography';

import { Maybe } from '../../shared/types/graphql-types';

import styles from './product-title.scss';

interface ProductTitleProps {
  brand?: Maybe<string>;
  className?: string;
  link?: Maybe<string>;
  name?: Maybe<string>;
  onClick?: (event: React.SyntheticEvent) => void;
  size?: Maybe<string>;
}

function ProductTitle(props: ProductTitleProps) {
  const { brand, className, link, name, onClick, size } = props;

  if (!brand && !name && !size) {
    return null;
  }

  const children = (
    <>
      {brand && (
        <Typography
          className={cn(styles['brand'], 'product-title__brand')}
          tag="span"
          variant="H6"
        >
          {brand}
        </Typography>
      )}

      {name && (
        <Typography
          className={cn(styles['name'], 'product-title__name')}
          tag="span"
          variant="H4"
          weight="black"
        >
          {name}
        </Typography>
      )}

      {size && (
        <Typography
          className={cn(styles['size'], 'product-title__size')}
          tag="span"
        >
          {size}
        </Typography>
      )}
    </>
  );

  if (link || typeof onClick === 'function') {
    return (
      <Button
        className={cn(styles['container'], `${className || ''} product-title`)}
        href={link || ''}
        onClick={onClick}
      >
        {children}
      </Button>
    );
  } else {
    return (
      <div
        className={cn(styles['container'], `${className || ''} product-title`)}
      >
        {children}
      </div>
    );
  }
}

export default ProductTitle;
